<template>
    <div>
        <div class="row topCardGrid">
            <sp-card :valor="MaiorDeficit" :descricao="$t('graficosEducacao.demandaTotal')" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"></sp-card>
            <sp-card :valor="demandaBercario" :descricao="$t('graficosEducacao.demanda0-1anos')" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"></sp-card>
            <sp-card :valor="demandaJardim" :descricao="$t('graficosEducacao.demanda2-3anos')" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"></sp-card>
        </div>
        <div class="row topCardGrid">
            <sp-card :valor="admDireta" :valorProgressBar="admDiretaPercentual" :descricao="$t('graficosEducacao.matriculasAdmDireta')" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"></sp-card>
            <sp-card :valor="admIndireta" :valorProgressBar="admIndiretaPercentual" :descricao="$t('graficosEducacao.matriculasAdmIndireta')" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"></sp-card>
            <sp-card :valor="parceira" :valorProgressBar="parceiraPercentual" :descricao="$t('graficosEducacao.matriculasConveniada')" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"></sp-card>
        </div>

        <div class="row grafico-segmentado">
            <div class="flex lg6 md6 xs12">
                <sp-360-panel :title="$t('graficosEducacao.CoberturaRedeCreche')"
                    :tooltipOptions="tooltipCreche"
                    :footerComplementar="$t('graficosEducacao.disclaimerFilaCreche')"
                    :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
                    <sp360-chart :data="piechartmatriculascreche" type="pie"
                        :options="piechartmatriculascrecheOptions" />
                </sp-360-panel>

            </div>
            <div class="flex lg6 md6 xs12">
                <sp-360-panel :title="$t('graficosEducacao.DeficitRedeCreche')"
                    :tooltipOptions="tooltipCreche"
                    :footerComplementar="$t('graficosEducacao.disclaimerFilaCreche')"
                    :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
                    <sp360-chart :data="piechartdeficitcreche" type="pie"
                        :options="piechartdeficitcrecheOptions" />
                </sp-360-panel>
            </div>
        </div>

        <div class="row">
          <div class="flex md12 xs12">
            <sp-360-panel :title="tabela.titulo" :tooltipOptions="tabela.topTooltipOptions" :footerComplementar="$t('graficosEducacao.tableFields.rodape')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
                <div class="flex-box" style="min-height: 100%">
                    <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP"
                        :habilitarAnimacaoClique="false"></sp-map>
                    <sp360-data-table id="tabelaFilaCreche" ref="filaCreche" :apiMode="false"
                        :data="tabela.tableData.data" :fields="tabela.tableFields"
                        :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" />
                </div>
            </sp-360-panel>
          </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import * as d3 from 'd3'

export default {
  name: 'fila-creche',
  components: {
    SpCard,
    SpMap,
    MethGlob,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
  },

  data () {
    return {
      fonte: '',
      dataRef: '',
      mapaCores: {
        claro: '#f1f1fa',
        medio: '#9c9cd4',
        escuro: '#3b3b72',
      },
      cores: [],
      dados: {},
      totais: {},
      agrupamentos: {},
      demandaGeral: [],

      redeCreche: {},

      matriculasCreche: 0,
      piechartmatriculascreche: {},
      piechartmatriculascrecheOptions: {},
      piechartdeficitcreche: {},
      piechartdeficitcrecheOptions: {},
      listaDemografia: {},

      tooltipCreche: {
        content: this.$t('graficoEducacao.tooltipCreche'),
        placement: 'bottom',
      },

      tabela: {
        titulo: this.$t('graficosEducacao.tableFields.title'),
        tableData: {
          'data': [],
        },
        tableFields: [{
          name: 'nome',
          title: this.$t('graficosEducacao.tableFields.sub'),
          width: '20%',
        },
        {
          name: 'demandaTotal',
          sortField: 'demandaTotal',
          title: this.$t('graficosEducacao.tableFields.demandaTotal'),
          callback: MethGlob.thousandSeparator,
          width: '12%',
        },
        {
          name: 'bercario_i',
          sortField: 'bercario_i',
          title: this.$t('graficosEducacao.tableFields.categoriaPrefix') + ' ' +
             this.$t('graficosEducacao.turmasCreche.bercario_i_eta'),
          callback: MethGlob.thousandSeparator,
          width: '12%',
        },
        {
          name: 'bercario_ii',
          sortField: 'bercario_ii',
          title: this.$t('graficosEducacao.tableFields.categoriaPrefix') + ' ' + this.$t(
            'graficosEducacao.turmasCreche.bercario_ii_eta'),
          callback: MethGlob.thousandSeparator,
          width: '12%',
        },
        {
          name: 'mini_grupo_i',
          sortField: 'mini_grupo_i',
          title: this.$t('graficosEducacao.tableFields.categoriaPrefix') + ' ' + this.$t(
            'graficosEducacao.turmasCreche.mini_grupo_i_eta'),
          callback: MethGlob.thousandSeparator,
          width: '12%',
        },
        {
          name: 'mini_grupo_ii',
          sortField: 'mini_grupo_ii',
          title: this.$t('graficosEducacao.tableFields.categoriaPrefix') + ' ' + this.$t(
            'graficosEducacao.turmasCreche.mini_grupo_ii_eta'),
          callback: MethGlob.thousandSeparator,
          width: '12%',
        },
        ],

        sortFunctions: {
          'demandaTotal': MethGlob.ordenaTabelaParseInt,
          'bercario_i': MethGlob.ordenaTabelaParseInt,
          'bercario_ii': MethGlob.ordenaTabelaParseInt,
          'mini_grupo_i': MethGlob.ordenaTabelaParseInt,
          'mini_grupo_ii': MethGlob.ordenaTabelaParseInt,
        },

        topTooltipOptions: {
          content: this.$t('graficosEducacao.filaDaCrecheNotaTecnica') + '</br>' + this.$t(
            'graficosEducacao.filaDaCrecheNotaTecnica2'),
          placement: 'bottom',
          classes: 'va-tooltip customTooltip',
        },
        itemsPerPage: 12,
      },

      //.............
      sigla: '',

    }
  },

  computed: {
    demandaJardim: function () {
      return this.totais.demandaJardim | 0
    },
    demandaBercario: function () {
      return this.totais.demandaBercario | 0
    },
    MaiorDeficit: function () {
      return (this.totais.demandaJardim + this.totais.demandaBercario) | 0
    },
    admDireta: function () {
      return this.redeCreche[0] | 0
    },
    admIndireta: function () {
      return this.redeCreche[1] | 0
    },
    parceira: function () {
      return this.redeCreche[2] | 0
    },
    admDiretaPercentual: function () {
      return this.redeCreche[3] | 0
    },
    admIndiretaPercentual: function () {
      return this.redeCreche[4] | 0
    },
    parceiraPercentual: function () {
      return this.redeCreche[5] | 0
    },
  },

  created () {
    Promise.all([
      this.$store.dispatch('servicosSME/buscarFilaCreche', { intervalo: 'MAIS_RECENTE' }),
      this.$store.dispatch('servicosSME/buscarMatriculas', { intervalo: 'MAIS_RECENTE', agrupamentos: 'POR_CICLO_ENSINO' }),
      this.$store.dispatch('populacao/buscarPopulacaoPorIdadeSexo'),
      this.$store.dispatch('servicosSME/buscarRedeEnsino', { agrupamento: 'NENHUM' }),
      this.$store.dispatch('servicosSME/buscarMatriculas', { intervalo: 'MAIS_RECENTE', agrupamento: 'NENHUM' }),
    ]).then((respostas) => {
      this.cores = [CorUtils.getCorPorNomeSp360('verde-medio'),
        CorUtils.getCorPorNomeSp360('azul-columbia-medio'),
        CorUtils.getCorPorNomeSp360('amarelo-medio'),
        CorUtils.getCorPorNomeSp360('vermelho-medio'),
        CorUtils.getCorPorNomeSp360('purpura-escuro'),
      ]

      this.sigla = respostas[0].sigla_orgao
      this.fonte = respostas[0].sigla_orgao + '-' + respostas[0].fonte
      this.dataRef = new Date(respostas[0].data_referencia_dado).toLocaleDateString('pt-BR')
      this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

      this.dados = _.orderBy(respostas[0].data, [ o => (o.bercario_i + o.bercario_ii + o.mini_grupo_ii + o.mini_grupo_i) ], 'desc')
      this.redeCreche = this.calculaCoberturaCreches(respostas[4].data)
      this.listaDemografia = _.sortBy(respostas[2].data.data, ['id'], ['desc'])
      this.totais = this.calcularTotalizadores(this.dados)
      this.calcularMatriculasPorRegiao(respostas[3].data)
      this.updateTabela(this.dados)
      this.calcularMatricula(respostas[1].data)
      this.populatePiechartMatriculasCreche()
      this.populatePiechartDeficitCreche()

      this.pintarRegiao(this.dados)
      this.$refs.mapa.setLegenda(this.dados[this.dados.length - 1].demandaTotal, this.dados[0].demandaTotal, this.$t('graficosEducacao.textoEixoLegenda.demandaCreche'))
      this.criarLegenda()
    }).catch((error) => {
      console.error(error)
    })
  },

  methods: {

    filtrarPorRegiao (id) {
      let idNum = MethGlob.idSvgToNumeric(id)
      if (this.ultimoClickNomeSub != id) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
      } else {
        this.$refs.mapa.limparClick(id)
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        this.munAtual = this.$t('graficosEducacao.geral')
      }
    },

    getTotalizador () {
      return {
        pontosCentrais: {},
        solicitacoesCadastro: 0,
        bercario_i: 0,
        bercario_ii: 0,
        mini_grupo_i: 0,
        mini_grupo_ii: 0,
        demandaBercario: 0,
        demandaJardim: 0,
        MaiorDeficit: {
          bercario_i: {},
          bercario_ii: {},
          mini_grupo_i: {},
          mini_grupo_ii: {},
        },
      }
    },

    updateTabela (dados) {
      this.$set(this.tabela.tableData, 'data', dados)
    },

    criarLegenda () {
      this.$refs.mapa.definirLegenda([this.mapaCores.claro, this.mapaCores.escuro], [ this.$t('graficosEducacao.textoEixoLegenda.demandaCreche') ])
    },

    // Pinta as areas do mapa de acorco com um valor arbitrario
    // TODO : Delimitar uma formula para o farol.
    pintarRegiao (dados) {
      let colorScale = d3.scaleLinear()
        .domain([dados[this.dados.length - 1].demandaTotal, dados[0].demandaTotal])
        .range([this.mapaCores.claro, this.mapaCores.escuro])

      dados.forEach((element) => {
        let id = 'sub' + element.id_subprefeitura
        this.$refs.mapa.pintarRegiao(id, colorScale(element.demandaTotal))
      })
    },

    // Calcula os Totais gerais e define qual o maior valor de demanda por segmento para uma unica entidade.
    calcularTotalizadores (filaCreche) {
      let arr = []
      let totais = this.getTotalizador()
      filaCreche.forEach(creche => {
        creche.demandaTotal = creche.bercario_i + creche.bercario_ii + creche.mini_grupo_ii + creche
          .mini_grupo_i
        arr.push(creche.demandaTotal)
        totais = this.redutor(totais, creche)
      })

      totais.solicitacoesCadastro = (totais.bercario_i + totais.bercario_ii + totais.mini_grupo_i + totais
        .mini_grupo_ii)

      totais.pontosCentrais = MethGlob.calculaPontosCentrais(arr)

      return totais
    },

    formatarNumeros (num) {
      return MethGlob.thousandSeparator(num)
    },

    // Soma os valores dos atributos de N a um acumulador e devolve esse objeto.
    redutor (acumulador, n) {
      acumulador.bercario_i += n.bercario_i
      acumulador.bercario_ii += n.bercario_ii
      acumulador.mini_grupo_i += n.mini_grupo_i
      acumulador.mini_grupo_ii += n.mini_grupo_ii
      acumulador.demandaBercario += n.bercario_i + n.bercario_ii
      acumulador.demandaJardim += n.mini_grupo_i + n.mini_grupo_ii
      return acumulador
    },

    populatePiechartMatriculasCreche () {
      let criancas = this.listaDemografia[0].dados[0]
      criancas.total = criancas.feminino + criancas.masculino

      this.piechartmatriculascreche = {}
      this.piechartmatriculascreche.labels = [
        this.$t('graficosEducacao.pieChartMatriculasCreche.foraCreche'),
        this.$t('graficosEducacao.pieChartMatriculasCreche.matriculadaCreche'),
        this.$t('graficosEducacao.pieChartMatriculasCreche.naFilaCreche'),
      ]
      this.piechartmatriculascreche.datasets = []

      let a = (this.matriculasCreche + this.totais.solicitacoesCadastro)
      let b = (this.matriculasCreche + this.totais.solicitacoesCadastro)

      let dataset = {
        backgroundColor: this.cores,
        data: [criancas.total - a, // Crianças fora da Fila
          this.matriculasCreche,
          this.totais.solicitacoesCadastro, // Fila
        ],
      }

      this.piechartmatriculascrecheOptions = {
        legend: {
          position: 'bottom',
          align: 'center',
          labels: {
            usePointStyle: 'true',
          },
        },
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'pie'),
        },
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => value ? MethGlob.formataPercentual(this.percentage(value, criancas.total)) + '\n ' + MethGlob.thousandSeparator(parseFloat(value)) : null,
            clamp: true,
            display: 'auto',
            anchor: 'center',
            font: {
              size: 14,
              weight: 'bold',
            },
          },
        },
      }

      this.piechartmatriculascreche.datasets.push(dataset)
    },

    populatePiechartDeficitCreche () {
      let cores = this.cores.slice(1)

      this.piechartdeficitcreche = {}
      this.piechartdeficitcreche.labels = [
        this.$t('graficosEducacao.pieChartDeficitCreche.labels.deficitBercario'),
        this.$t('graficosEducacao.pieChartDeficitCreche.labels.deficitCreche'),
      ]
      this.piechartdeficitcreche.datasets = []

      let a = (this.matriculasCreche + this.totais.solicitacoesCadastro)
      // let b = (this.totalMatriculas + this.totais.solicitacoesCadastro)

      let dataset = {
        backgroundColor: cores,
        data: [
          (this.totais.bercario_i + this.totais.bercario_ii),
          (this.totais.mini_grupo_i + this.totais.mini_grupo_ii),
        ],
      }

      this.piechartdeficitcrecheOptions = {
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: 'true',
          },
        },
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'pie'),
        },
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => {
              return value ? MethGlob.formataPercentual(this.percentage(value, a)) + '\n ' + MethGlob.thousandSeparator(parseFloat(value)) : null
            },
            display: 'auto',
            clamp: true,
            anchor: 'center',
            font: {
              size: 14,
              weight: 'bold',
            },
          },
        },
      }

      this.piechartdeficitcreche.datasets.push(dataset)
    },

    calcularMatricula (dados) {
      dados.forEach(e => {
        if (e.ciclo_ensino == 'CRECHE') {
          this.matriculasCreche += e.matriculas
        }
      })
    },

    percentage (partialValue, totalValue) {
      return ((100 * partialValue) / totalValue).toFixed(2)
    },

    calcularMatriculasPorRegiao (dados) {
      let arSubs = []
      this.unidadesPorSub = _.groupBy(dados, 'nome_subprefeitura')
      this.turmas = []

      for (const key in this.unidadesPorSub) {
        const e = this.unidadesPorSub[key]
        e.vagasCreche = 0
        e.forEach(a => {
          e.vagasCreche += (a.total_matriculas_creche || 0)
        })
      }
      this.turmas = _.orderBy(this.turmas, 'total', 'desc')
    },

    calculaCoberturaCreches (dados) {
      let direta = 0
      let indireta = 0
      let conveniada = 0
      let total = 0

      dados.forEach(d => {
        if (d.ciclo_ensino === 'CRECHE') {
          switch (d.tipo_escola) {
            case 'CECI':
            case 'CEMEI':
            case 'CEU CEI':
            case 'CCI/CIPS':
            case 'CEI DIRET':
              direta += d.matriculas

              break
            case 'CEI INDIR':
              indireta += d.matriculas
              break
            case 'CR.P.CONV':
            case 'ESC.PART.':
              conveniada += d.matriculas
              break
          }
        }
      })

      total = direta + indireta + conveniada
      let dataset = [direta,
        indireta,
        conveniada,
        ...MethGlob.arredondaPorcentagens([(100 * direta / total), (100 * indireta / total), (100 * conveniada / total)], 0),
        total,
      ]
      return dataset
    },

  }, // Methods
}

</script>

<style lang="scss" scoped>

    .flex-box {
        display: flex;
    }

    #mapaSP {
        width: 25%;
    }

    #tabelaFilaCreche {
        width: 75%;
        height: auto
    }

</style>

<style lang="scss">
    .customTooltip {
        .tooltip-inner {
            border-radius: 16px;
            padding: 5px 10px 4px;
            text-align: left;
            background-color: #333;
            color: #FFF;
        }
    }

      @media (min-width: 1001px) {
          #mapaSP{
              width: 45%;
          }

          #tabelaFilaCreche{
              width: 55%;
          }

          .flex-box{
            display: flex;
          }
      }
      @media (max-width: 1000px) {
          #mapaSP{
              width: 45%;
          }

          #tabelaFilaCreche{
              width: 55%;
          }

          .flex-box{
            display: flex;
          }
      }

</style>
